/* istanbul ignore file */
import React from 'react';
import { Switch } from 'react-router-dom';
import { AppContextProvider } from './AppContext';
import Callback from './Callback/Callback';
import {
  AccountPage,
  CommunicationsPage,
  ConnectedAccountsPage,
  ContactUsPage,
  HomePage,
  MyOrganisationEntry,
  NotFoundPage,
  PersonalInfoPage,
  ProfessionalDevelopmentApprovalsPage,
  routes,
} from './Pages';
import { ProtectedRoute, PublicRoute } from './Route';

const AppRoutes: React.FC = () => {
  return (
    <Switch>
      <ProtectedRoute
        exact
        path={routes.Communications.path}
        component={CommunicationsPage}
      />
      <ProtectedRoute
        exact
        path={routes.ConnectedAccounts.path}
        component={ConnectedAccountsPage}
      />
      <ProtectedRoute
        exact
        path={routes.PersonalInfo.path}
        component={PersonalInfoPage}
      />
      <ProtectedRoute
        path={routes.MyOrganisation.path}
        component={MyOrganisationEntry}
        onlyDelegate
      />
      <ProtectedRoute
        exact
        path={routes.Account.path}
        component={AccountPage}
      />
      <ProtectedRoute
        exact
        path={routes.ProfessionalDevelopmentApprovals.path}
        component={ProfessionalDevelopmentApprovalsPage}
      />
      <PublicRoute
        exact
        path={routes.ContactUs.path}
        component={ContactUsPage}
      />
      <ProtectedRoute exact path={routes.Home.path} component={HomePage} />
      <PublicRoute path={routes.Callback.path} component={Callback} />
      <PublicRoute component={NotFoundPage} />
    </Switch>
  );
};

const App: React.FC = () => {
  return (
    <AppContextProvider>
      <AppRoutes />
    </AppContextProvider>
  );
};
export default App;
